import yang from "refractor/yang";
export default yang;